<template>
  <div v-if="community" class="type">
    <div>
      <img v-if="community.type.toLowerCase() === 'private'"
           src="@/assets/PrivateCommunityIcon.svg"
           alt="private community icon"
      />
    </div>
    <div>
      <img v-if="community.isBroadcast === true"
           src="@/assets/RSS.svg"
           alt="broadcast community icon"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'CommunityType',
  props: {
    community: {
      type: Object,
      required: false,
      default: () => {
      }
    }
  }
}

</script>

<style scoped lang="scss">
.type {
  display: flex;
}

img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
</style>
